import { formatDate } from 'shared/helpers/parsers/formaters';

const parseFieldValue = (user, date, dateFormat) =>
  (user || date) &&
  `${user ? `${user.firstName} ${user.lastName}` : ''}
  ${date ? `(${formatDate(date, dateFormat)})` : ''}`;

export { parseFieldValue };
